export default __webpack_public_path__ + "static/media/pic85.faf21df9.jpg";